// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__ohb4J","ranges":"BmiRanges_ranges__1UcEk"};